import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { administratorMethods } from "../api/apiMethods";
import { canManageAdministrators } from "../common/helpers/municipalityRoles";
import { AuthenticatedUserContext } from "../contexts/AuthenticatedUserContext";
import { useQueryErrorHandling } from "../hooks/useQueryErrorHandling";
import useSelectedMunicipalityId from "../hooks/useSelectedMunicipalityId";
import { queryKeys } from "./queryKeys";

export const useAllAdministratorsQuery = () => {
    const { authUserData } = useContext(AuthenticatedUserContext);
    const municipalityId = useSelectedMunicipalityId();

    const query = useQuery({
        queryKey: queryKeys.administrator.all(municipalityId),
        queryFn: () => {
            if (!authUserData) {
                throw new Error("No auth user data");
            }

            if (!municipalityId) {
                throw new Error("No municipality Id");
            }

            try {
                return administratorMethods(municipalityId).getAllAdministrators();
            } catch (error: any) {
                throw new Error(error.message);
            }
        },
        select: ({ userlist }) => userlist,
        enabled:
            !!authUserData &&
            canManageAdministrators(authUserData.municipalityRole),
        staleTime: Infinity,
    });

    useQueryErrorHandling(query, "Kunde inte hämta administratörer.");

    return query;
};
